import './Box.scss';

import BoxContent from 'components/Box/BoxContent';
import BoxHeader from 'components/Box/BoxHeader';
import CustomBox from 'components/Box/CustomBox';
import React from 'react';

interface Props {
  header?: string | React.ReactNode;
  children: any;
  className?: string;
}

export default (props: Props) => {
  const header = props.header && (
    <BoxHeader>
      <span>{props.header}</span>
    </BoxHeader>
  );
  return (
    <CustomBox className={props.className}>
      {header}
      <BoxContent>{props.children}</BoxContent>
    </CustomBox>
  );
};
